// text node formatting: bitwise flags matching lexical's internal format
export const DEFAULT_FORMAT = 0
export const IS_BOLD = 0b1
export const IS_ITALIC = 0b10
export const IS_STRIKETHROUGH = 0b100
export const IS_UNDERLINE = 0b1000
export const IS_CODE = 0b10000
export const IS_SUBSCRIPT = 0b100000
export const IS_SUPERSCRIPT = 0b1000000
export const IS_HIGHLIGHT = 0b10000000
